<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">Broker Details</h5>
  <div class="d-flex gap-2 align-items-center  ms-auto">
    <button type="button" 
            class="btn btn-outline-secondary btn-sm" 
            (click)="openAuditForForm()">
      <fa-icon [icon]="faHistory"></fa-icon>
    </button>
    <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
  </div>
</div>

<div class="modal-body">
  <form [formGroup]="brokerDetails" autocomplete="off">

    <div class="mb-3 row">
      <label class="col-sm-4 col-form-label">Individual Financial Advisor</label>
      <div class="col-sm-8">
        <select class="form-select" 
                formControlName="faUserId" 
                (change)="updateField()"
                [disabled]="!authService.isPortalManager() && !authService.isPortalAdmin()">
          <option *ngFor="let user of faUsers" [ngValue]="user.id">
            {{user.firstName}} {{user.lastName}}
          </option>
        </select>
      </div>
    </div>

    <div class="mb-3 row">
      <label class="col-sm-4 col-form-label">Financial Advisor Company</label>
      <div class="col-sm-8">
        <p class="form-control-plaintext">{{brokerDetails.controls['financialAdvisorCompanyName'].value}}</p>
      </div>
    </div>

    <div class="mb-3 row">
      <label class="col-sm-4 col-form-label">Financial Advisor Contact Number</label>
      <div class="col-sm-8">
        <input type="text" 
               class="form-control" 
               formControlName="financialAdvisorContactNumber" 
               (change)="updateField()">
      </div>
    </div>

    <div class="mb-3 row">
      <label class="col-sm-4 col-form-label">Financial Advisor Email Address</label>
      <div class="col-sm-8">
        <p class="form-control-plaintext">{{brokerDetails.controls['faUser'].value?.emailAddress}}</p>
      </div>
    </div>

    <div class="mb-3 row">
      <label class="col-sm-4 col-form-label">Broker Reference</label>
      <div class="col-sm-8">
        <input type="text" 
               class="form-control" 
               formControlName="brokerReference" 
               (change)="updateField()">
      </div>
    </div>

    <div class="mb-3 row">
      <label class="col-sm-4 col-form-label">Financial Advisor Fee</label>
      <div class="col-sm-8">
        <div class="input-group">
          <span class="input-group-text">£</span>
          <input type="number" 
                 class="form-control" 
                 formControlName="financialAdvisorFee" 
                 (change)="updateField()">
        </div>
      </div>
    </div>

  </form>
</div>